export default {
    install(Vue, options) {
        Vue.mixin({
            methods: {
                notifyDefault(message = "message", type = "success", timeout = 10000) {
                    const mainAlert = document.getElementById("mainAlert");
                    const mainAlertTxt = document.getElementById("mainAlertTxt");

                    mainAlertTxt.innerText = message;
                    mainAlert.classList.add("mainAlertShow");
                    mainAlert.classList.add(type);

                    setTimeout(() => {
                        mainAlert.classList.remove("mainAlertShow")
                        mainAlert.classList.remove(type)
                    }, timeout);

                },
                notifyDanger(message = "System Error", timeout) {
                    this.notifyDefault(message, 'alert_danger', timeout)
                },
                notifyError(message, timeout) {
                    if(typeof message !== 'string'){
                       message = this.formatErrorMessages(message)
                    }
                    this.notifyDanger(message, timeout);
                },
                notifyWarning(message, timeout) {
                    this.notifyDefault(message, 'alert_warning', timeout)
                },

                notifyInfo(message, timeout) {
                    message = message.text ?
                        `${this.$t("msg.copied")}: ${message.text}` : message;
                    this.notifyDefault(message, 'alert_info', timeout)
                },

                notifySuccess(message, timeout) {
                    this.notifyDefault(message, 'alert_success', timeout)
                },
                onCopySuccess(message) {
                    this.notifyInfo(message)
                },

                onCopySuccessInformation() {
                    this.notifyInfo('Copied')
                },

                onCopySuccessInformationOTC() {
                    this.notifyInfo(this.$t('msg.copy_alert_info_otc'))
                },

                onCopyError(message) {
                    this.notifyInfo(message)
                },
                formatErrorMessages(errors) {
                    let message = "";
                    if (Array.isArray(errors)) {
                        errors.forEach(item => {
                            let messageArray = [];

                            if (item.message.indexOf(",") !== -1) {
                                messageArray = item.message.split(",");
                                message = message
                                    ? message + "\n" + messageArray.join(`\n`)
                                    : message + messageArray.join(`\n`);
                            } else {
                                message = message ? `${message}\n${item.message}` : item.message;
                            }
                        });
                    } else {
                        return errors.message
                    }
                    return message
                }
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/utils/stratum_notify/index.js